<div *ngIf="sequenceSearch$ | async as sequenceSearch">
  <div *ngIf="sequenceSearch.isLoading" class="loading-container">
    <div class="text-lg font-medium">Finding Sequence...</div>
    <mat-spinner color="accent" [diameter]="32"></mat-spinner>
  </div>
</div>